<div>
	<sample-sales-grid></sample-sales-grid>
	<sample-revenue-chart></sample-revenue-chart>
</div>